import { render, staticRenderFns } from "./ChangeStatusModal.vue?vue&type=template&id=684f6a4f&scoped=true"
import script from "./ChangeStatusModal.vue?vue&type=script&lang=js"
export * from "./ChangeStatusModal.vue?vue&type=script&lang=js"
import style0 from "./ChangeStatusModal.vue?vue&type=style&index=0&id=684f6a4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684f6a4f",
  null
  
)

export default component.exports